import { CalendarClock } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { useChildMakeups } from '@/hooks/use-makeups';
import { formatDate, formatTime } from '@/lib/format';

export function MakeupsSection({ childId }: { childId: string }) {
  const { data: makeups, isLoading } = useChildMakeups(childId);

  if (isLoading || !makeups || makeups.length === 0) return null;

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-base">
          <CalendarClock className="w-4 h-4 text-orange-500" />
          Pending Makeups
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-2">
        {makeups.map(makeup => (
          <div
            key={makeup.id}
            className="flex items-center justify-between p-3 border rounded-lg"
          >
            <div>
              <p className="text-sm text-foreground">
                Missed: {makeup.originalSession
                  ? `${formatDate(makeup.originalSession.date)} ${formatTime(makeup.originalSession.startTime)}`
                  : 'Unknown session'}
              </p>
              {makeup.makeupSession && (
                <p className="text-xs text-primary font-medium">
                  Makeup scheduled: {formatDate(makeup.makeupSession.date)} {formatTime(makeup.makeupSession.startTime)}
                </p>
              )}
            </div>
            <Badge
              className={
                makeup.status === 'pending'
                  ? 'bg-orange-100 text-orange-700'
                  : 'bg-blue-100 text-blue-700'
              }
            >
              {makeup.status}
            </Badge>
          </div>
        ))}
      </CardContent>
    </Card>
  );
}
